function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const overviewUrls = {
  site: '/sites/types/{type_id}',
  tc: '/routecontrols/types/{type_id}'
};

const urls = {
  site: '/sites/types/{type_id}/lines',
  tc: '/routecontrols/types/{type_id}/lines'
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  detailTitle: '',
  deleteTitle: 'dit item',
  overviewUrl(context) {
    return overviewUrls[getType(context)];
  },
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitetypes/{type_id}/lines/'
};
